'use strict';

var processInclude = require('base/util');

processInclude(require('./video'));
processInclude(require('./hero'));
processInclude(require('./hotspot'));
processInclude(require('./header'));
processInclude(require('./brands'));
// processInclude(require('./menuCustomerCare')); // This module is currently not used, as the menu is hidden in the customer care page. It can be enabled if needed in the future.
processInclude(require('./newsletterModal'));
processInclude(require('./productSlider'));
processInclude(require('./readingBar'));
processInclude(require('./blog'));
processInclude(require('./productFinder'));
processInclude(require('./appLogin'));
processInclude(require('./einsteinCarousel'));
